export default{
    setActiveMenu(state, payload) {
        state.activeMenu = payload;
    },
    setActiveMobileMenu(state, payload) {
      state.activeMobileMenu = payload;
    },
    setActiveSubMenu(state, payload) {
        state.activeSubMenu = payload;
    },
    setViewPost(state,payload){
        state.viewPost.push(payload);
    },
    setSearchpost_userId(state,payload){
      state.searchpost_userId = payload;
    },
    setSearchpost_content(state,payload){
      state.searchpost_content = payload;
    },
    setRecommend(state, payload){
        if(!state.recommend.some(recommend => recommend === payload))
        {
            state.recommend.push(payload);
        }else{
            //추천했다 취소 할때
            const idx = state.recommend.indexOf(payload)
            if (idx > -1) state.recommend.splice(idx, 1)
        }
    },
    setDocuments(state, payload)
    {
        //menu 셋팅
        //console.log("메뉴셋팅",payload['공지']);
        let menus=[
            {
              name:'Mentory',
              title:'멘토리',
              link:'/main/coaches',
              type:'',
              subs:[
                payload['멘토리'],
                // { title:'테스트', name:'test'},
                // { title:'테스트2', name:'test2'},
              ]
            },
            {
                name:'Gamegrade',
                title:'게임등급',
                link:'/main/coaches',
                type:'',
                subs:[
                  payload['게임등급'],
                  { title:'게임등급', name:'gracsearch',menu:'게임등급'},
                  // { title:'테스트', name:'test'},
                  // { title:'테스트2', name:'test2'},
                ]
              },
            {
              name:'GameJoa',
              title:'게임조아',
              link:'/main/community/free',
              type:'',
              subs:[
                payload['게임조아'],
                { title:'출석', name:'attendance',menu:'게임조아'},
              ]
            },
            {
              name:'SteamWeaky',
              title:'스팀위키',
              link:'/main/community/SteamWeaky/all',
              type:'',
              subs:[
                payload['스팀위키'],                
              ]
            },
            {
              name:'Community',
              title:'커뮤니티',
              link:'/main/community/free',
              type:'',
              subs:[
                payload['커뮤니티'],                
              ]
            },   
            {
              name:'Item',
              title:'아이템',
              link:'/main/item/list',
              routename:'itemlist',
              type:'normal',
              subs:[
                payload['아이템'],   
                { title:'아이템', name:'itemlist',menu:'Item'},                  
                { title:'P샵 몰', name:'goodslist',menu:'Item',icon:'parking'},           
                { title:'마이아이템', name:'MyItemBuy',menu:'Item'},                    
              ]
            },           
          ];

        state.menus = menus;
        state.documents = payload;
    },

    setSwiperIndexHome(state, payload)
    {
      state.swiperIndexHome  = payload 
    },
    setSwiperIndexItem(state, payload)
    {
      state.swiperIndexItem  = payload 
    }
};
